<template>
    <div>
        <v-search :formContent="formContent" :SearchForm="recordForm" :inline="true" @resetFn="resetFn"
            @searchFn="search"></v-search>
        <el-table stripe :data="tableData" ref="multipleTable" :header-cell-style="headCellStyle" :height="tableHeight"
            highlight-current-row v-loading="loading">
            <el-table-column :label="$t('public.process_time')" prop="processTime" show-overflow-tooltip
                align="center">
                <template #default="{ row }">
                    <span>{{ $timetransition(row.processTime) }}</span>
                </template>
            </el-table-column>
            <el-table-column :label="$t('public.reason')" prop="reasonText" show-overflow-tooltip />
            <el-table-column :label="$t('public.table_desc')" prop="desc" show-overflow-tooltip />
            <el-table-column :label="$t('public.handler')" prop="processor" show-overflow-tooltip />
            <el-table-column width="80" :label="$t('public.table_operation')" prop="opreta" align="center">
                <template #default="{ row }">
                    <el-button type="text" size="small" icon="el-icon-tickets" :title="$t('integration.details')"
                        @click="detailFn(row)">
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <Pagination class="pagination" :total="total" :page.sync="recordForm.iDisplayStart"
            :limit.sync="recordForm.iDisplayLength" @pagination="getList"></Pagination>
            <dialogCom :isShow.sync="isShow" :row="row" />
    </div>
</template>

<script>
import { exProcess } from '@/api/modules/abnormal.js';
import dialogCom from './dialogCom.vue';
export default {
    name: 'recordCom',
    props: ['rowData'],
    components:{dialogCom},
    data() {
        return {
            recordForm: {
                iDisplayStart: 0,
                iDisplayLength: 15,
                exId: '',
                time: []
            },
            formContent: [
                {
                    id: 1,
                    text: 'public.process_time',
                    type: 'datetimerange',
                    paramsName: 'time',
                    isChooze: true,
                },
            ],
            tableHeight: '570px',
            tableData: [],
            total: 0,
            loading: false,
            isShow:false,
            row:{}
        }
    },
    mounted() {
        this.getList();

    },
    methods: {
        getList() {
            this.loading = true;
            this.recordForm.exId = this.rowData.id;
            exProcess(this.recordForm).then(res => {
                this.tableData = res.result;
                this.total = res.pageInfo.total;
            }).finally(() => {
                this.loading = false;
            })
        },
        resetFn() {
            this.recordForm = {
                time: [],
                iDisplayLength: 15,
                iDisplayStart: 0
            }
            this.getList()
        },
        search(params) {
            console.log(params);
            if (params.time.length > 0) {
                // 将时间定义为不可被枚举 从而阻止其提交至后台
                if (this.recordForm.propertyIsEnumerable('time')) {
                    Object.defineProperty(this.recordForm, 'time', {
                        value: this.recordForm.time,
                        enumerable: false,
                        configurable: true,
                        writable: true
                    });
                }

                this.recordForm.from = new Date(params.time[0]).getTime();
                this.recordForm.to = new Date(params.time[1]).getTime();
            }

            this.getList();
        },
        detailFn(row) {
            this.isShow = true;
            this.row = {...row}
         }
    }
}

</script>

<style lang="scss" scoped>
::v-deep .el-form {
    padding-top: 0 !important;
}

.pagination {
    padding-top: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
</style>